<template>
  <svg
    class="icon"
    width="46"
    height="51"
    viewBox="0 0 46 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M17.516 6.1105C23.3171 -1.13021 33.6521 -1.71073 41.6443 4.69246C49.6365 11.0956 51.3242 21.3084 45.5231 28.5491C37.6422 38.3859 15.797 39.0533 14.7992 39.0392C14.3617 39.0252 14.0202 38.7515 13.9111 38.3277C13.7478 37.4117 9.63449 15.9468 17.5154 6.11008L17.516 6.1105Z" fill="url(#paint0_linear)" />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="14.2661"
        y1="38.8644"
        x2="41.644"
        y2="4.69225"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="currentColor" stop-opacity="0.37" />
        <stop offset="1" stop-color="currentColor" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'DropSimple',
};
</script>
